import { id } from "date-fns/locale";
import { useEffect, useRef, useState } from "react"
import classes from './UserManagementList.module.css'
import { useDispatch, useSelector } from "react-redux";
import { Await, useNavigate } from "react-router-dom";
import Pill_Widget from "../../components/UI/Widgets/Pill_Widget";
import UseTimeDateFormat from "../../components/hooks/UseTimeDateFormat";
import BasicTable from "../../components/Table/Table/Table";
import { authActions } from "../../store/auth-Slice";
import DeleteIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/trash.png"
import SettingsIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/settings.png"
import deleteIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/delete.png"
import swapSettings from "../../assets/portalAssets/Swap arrow.png"
import mixpanel from "mixpanel-browser";
import Modal from "../../components/Modal/Modal";
import { changePortalRole, deleteGroupUser, deleteUserAccount, enableUserNotifications, switchInstallerMode, getSiteAnalytics } from "../../Api Methods/Api";
import Button1 from "../../components/UI/Button/Button1";
import installerActive from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/installer-on.png"
import installerInactive from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/installer off.png"
import ActiveNotificationBellIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Notification - On.svg"
import InactiveNotificationBellIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/Site/__Notification - Off.svg"
import DropdownList from "../../components/UI/Cards/DropdownList";
import AdminIcon from "../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/admin.png"
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import DataManager from "../../hooks/DataManager";
import check from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/check.png'
import invited from '../../assets/Portal Iconnography SVGs/PortalAppRealted _Icons/misc/invited.png'
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import Lottie from "lottie-react";
import successAnim from '../../assets/animations/success.json'
import failAnim from '../../assets/animations/fail.json'
import areYouSureAnim from '../../assets/animations/areYouSure.json'
import statClasses from '../Dashboard/Dashboard.module.css'
import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip, Legend } from 'chart.js'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { SelectButton } from 'primereact/selectbutton';
import DatePickerModal from "../../components/sub-components/Logs/DatePickerModal";
import { DateRangePicker } from 'rsuite';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { format } from "date-fns";
import { logoMap } from '../../helpers/GroupLogoMap';
import KnowioLogo from '../../assets/knowio-logo.png';
import { getBranding } from '../../Api Methods/Api';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const filterOptions = ["All Users", "Exclude Portal Users"]

const SkeletonBarChart = () => (
    <div className={classes.chartCard}>
        <div className={classes.skeletonBar} style={{ height: "14px", width: "40%", marginBottom: "16px" }} />
        <div className={classes.skeletonBar} style={{ height: "337px", width: "100%" }} />
    </div>
);

const SkeletonTableCard = () => (
    <div className={classes.chartCard}>
        <div className={classes.skeletonBar} style={{ height: "14px", width: "15%", marginBottom: "16px" }} />
        <div style={{ border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: "8px", padding: "8px" }}>
            {[...Array(5)].map((_, i) => (
                <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "14px 8px", borderBottom: i < 4 ? "1px solid rgba(0,0,0,0.1)" : undefined }}>
                    <div className={classes.skeletonBar} style={{ height: "12px", width: "55%" }} />
                    <div className={classes.skeletonBar} style={{ height: "12px", width: "40px" }} />
                </div>
            ))}
        </div>
    </div>
);

const SectionHeaderTime = ({ title, times, selectedTime, setSelectedTime, portalFilter, setPortalFilter, showModal, HandleCloseModal, modalTitle, onSelect, handleOK, disableDates, modalComponent, dateRange, setDateRange, generatePDF, topUserStats }) => (
    <div className={statClasses.sectionHeaderTime}>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
            <p
            className={statClasses.sectionTitle}
            style={{borderBottom: "3px solid #56AD9C", paddingBottom: "4px", width: "48%"}}>{title}</p>
            <SelectButton
                className={classes.filterToggle}
                value={portalFilter}
                onChange={(e) => setPortalFilter(e.value)}
                options={filterOptions}
            />
        </div>

        <div>
            <DatePickerModal show={showModal} onClose={HandleCloseModal} title={modalTitle} onSelect={onSelect}>
            {modalComponent}
            </DatePickerModal>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '28px', alignItems: 'flex-end' }}>
            <div className={statClasses.timeDropdown} style={{ display: "flex", justifyContent: "flex-end"}}>
                <DateRangePicker style={{
                    display: "flex",
                    border: "1px solid #00000099",
                    borderRadius: "8px",
                    height: "30px",
                    maxWidth: "50%"
                    }}
                    placement="bottomEnd"
                    format="yyyy.MM.dd"
                    onChange={handleOK}
                    shouldDisableDate={disableDates}
                    calendarSnapping={true}
                    appearance="subtle"
                    cleanable={true}
                    ranges={[]}
                    value={dateRange ? [new Date(dateRange[0]), new Date(dateRange[1])] : null}
                />
                <div className={statClasses.timeButtons}>
                    {times.map((time) => (
                        <button
                            key={time}
                            className={selectedTime === time ? statClasses.timeButtonActive : statClasses.timeButton}
                            onClick={() => {
                                setSelectedTime(time)
                                setDateRange(null)
                            }}
                        >
                            {time}
                        </button>
                    ))}
                </div>
            </div>
            {topUserStats && topUserStats.length > 0 && (
                <Button
                    label="Export PDF"
                    icon="pi pi-file-pdf"
                    style={{
                        height: "28px",
                        fontSize: "14px",
                        padding: "6px 10px",
                        lineHeight: "1",
                        width: '125px'
                    }}
                    onClick={generatePDF}
                />
            )}
        </div>
    </div>
);

const legendColors = ["#60e08f", "#6298ee", "#efbc65", "#df7474", "#75c71e", "#1eb9c7"];

const BarCard = ({ title, labels, values, colors, topUserData, onUserClick, chartRef }) => {
    const data = {
        labels,
        datasets: [{ label: "", data: values, backgroundColor: colors, borderWidth: 0 }],
    };
    return (
        <div className={classes.chartCard}>
            <p className={classes.chartTitle}>{title}</p>
            {topUserData && (
                <div className={classes.userLegend}>
                    {topUserData.slice(0, 10).map((item, index) => (
                        <div
                            key={item.fullName}
                            className={classes.userLegendItem}
                            onClick={() => item.userID != null && onUserClick && onUserClick(item.userID, item.fullName)}
                            style={{ cursor: item.userID != null && onUserClick ? 'pointer' : 'default' }}
                        >
                            <span className={classes.userLegendDot} style={{ backgroundColor: legendColors[index % legendColors.length] }} />
                            <span>{item.fullName}</span>
                        </div>
                    ))}
                </div>
            )}
            <div style={{ height: "300px" }}>
                <Bar ref={chartRef} data={data} options={{ indexAxis: 'y', responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false }, tooltip: { enabled: true } }, scales: { x: { beginAtZero: true, ticks: { stepSize: 1 } }, y: { grid: { display: false }, ticks: { autoSkip: false } } } }} />
            </div>
        </div>
    );
};

const TableCard = ({ title, topUserData, onUserClick }) => (
    <div className={classes.chartCard}>
        <p className={classes.chartTitle}>{title}</p>
        <DataTable value={topUserData} scrollable scrollHeight="400px" stripedRows style={{ border: "1px solid rgba(0, 0, 0, 0.1)", borderRadius: "8px", padding: "8px" }}>
            <Column field="fullName" header="User" body={(rowData) => (
                <span className={classes.tableUser} onClick={() => onUserClick(rowData.userID, rowData.fullName)}>
                    {rowData.fullName}
                </span>
            )} />
            <Column field="total_actions" header="Total Actions" />
        </DataTable>
    </div>
);

const UserList = ({data, setData, apiData, isGroup, update, setUpdate, searchQuery, isLoading, setIsLoading, isPortalUsers, hidePortalAccess}) => {
    console.log(data);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const token = useSelector(state => state.auth.token);
    const client = useSelector(state => state.auth.client);
    const role = useSelector(state => state.auth.role);
    const companyName = useSelector(state => state.auth.companyName);

    // A group's group_path is its full ancestor chain (e.g. "Root > CompanyA > SubGroup"). A
    // portalGroupName is only safe to display if it's your own group or one of its subgroups -
    // i.e. your own path is a prefix of its path - otherwise it's a group above your access level.
    const normalizeGroupPath = (path) => (path || '').split('>').map(s => s.trim()).filter(Boolean);
    const groups = JSON.parse(localStorage.getItem('groups') || '[]');
    const myGroupSegments = normalizeGroupPath(groups.find(g => g.name === companyName)?.group_path);
    console.log(groups);
    console.log(myGroupSegments);
    const isGroupWithinHierarchy = (groupName) => {
        if (!groupName) return false;
        const targetSegments = normalizeGroupPath(groups.find(g => g.name === groupName)?.group_path);
        console.log(groupName);
        console.log(targetSegments);
        return myGroupSegments.length > 0 && myGroupSegments.every((seg, i) => targetSegments[i] === seg);
    };

    const navigateToGroup = (groupName) => {
        const targetGroup = groups.find(g => g.name === groupName);
        if (!targetGroup) return;
        sessionStorage.setItem('groupClicked', targetGroup.name);
        sessionStorage.setItem('groupPath', targetGroup.group_path);
        sessionStorage.setItem('groupClickedID', targetGroup.id);
        navigate('/Dashboard/Groups/GroupSites');
    };

    const apiDataRef = useRef({ token, client });
    apiDataRef.current = { token, client };
    console.log(role);
    const [selectedUsers, setSelectedUsers] = useState([])
    const [successVisible, setSuccessVisible] = useState(false)
    const [failVisible, setFailVisible] = useState(false)
    const [confirmVisible, setConfirmVisible] = useState(false)
    const [userIDToDelete, setUserIDToDelete] = useState(null)
    const [selectedEmail, setSelectedEmail] = useState("")
    const [revokeVisible, setRevokeVisible] = useState(false)
    const [userIDToRevoke, setUserIDToRevoke] = useState(null)
    const [emailPopupVisible, setEmailPopupVisible] = useState(false)
    const [emailPopupRow, setEmailPopupRow] = useState(null)
    const [emailCopied, setEmailCopied] = useState(false)

    const savedState = JSON.parse(sessionStorage.getItem('userState') || 'null');
    const isFirstMount = useRef(true);

    const [activeTab, setActiveTab] = useState(savedState ? savedState.activeTab : 0)
    const [topUserStats, setTopUserStats] = useState(null);
    const [isLoadingUsers, setIsLoadingUsers] = useState(true);
    const [selectedTime, setSelectedTime] = useState(savedState ? savedState.selectedTime : "7D");
    const times = ["7D", "1M", "3M"];

    const now = new Date();
    const last7 = new Date();
    last7.setDate(now.getDate() - 7);
    const last30 = new Date();
    last30.setDate(now.getDate() - 30);
    const last90 = new Date();
    last90.setDate(now.getDate() - 90);

    const [brandingName, setBrandingName] = useState("");
    const userBarChartRef = useRef(null);
    const logo = logoMap[brandingName] || KnowioLogo;

    const [massActionsVisible, setMassActionsVisible] = useState(false)
    const [roleDialogVisible, setRoleDialogVisible] = useState(false)
    const [roleChangeLoading, setRoleChangeLoading] = useState(false)
    const [singleRoleUser, setSingleRoleUser] = useState(null)
    const [massRevokeVisible, setMassRevokeVisible] = useState(false)
    const [massRevokeLoading, setMassRevokeLoading] = useState(false)
    const [portalFilter, setPortalFilter] = useState(savedState ? savedState.portalFilter : "All Users");

     // daterange stuff
    const sixMonthsAgo = new Date();
    sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
    const [dateRange, setDateRange] = useState(savedState ? savedState.dateRange : null);
    const [dateModalComponent, setDateModalComponent] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [dateModalTitle, setDateModalTitle] = useState("Select a date range to view");

    const formatLocalDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}T12:00:00.000Z`;
      };

    const handleOK= (value) => {
        if (value) {
            setDateRange([formatLocalDate(value[0]), formatLocalDate(value[1])]);
            setSelectedTime(null)
        } else {
            setDateRange(null);
        }
    };
      
    const disableDates = (date) => {
        return date < sixMonthsAgo || date > now;
    };
    
    const HandleModalClose = () => {
        setShowModal(false)
    };
    
    const onSelect = () => {
        HandleCloseModal();
    };

    const massActionOptions = [
        ...(role === 'admin' ? [{ label: 'Change portal role', value: 'changeRole' }] : []),
        { label: 'Revoke access', value: 'revokeAccess' },
    ]

    const roleOptions = role === 'admin'
        ? ['Admin', 'Manager', 'Operator']
        : ['Operator']

    const ApiData = {
        token,
        client
    }
    const dataManager = new DataManager();

    const toggleUserSelection = (user) => {
        setSelectedUsers(prev =>
            prev.some(u => u.userID === user.userID)
                ? prev.filter(u => u.userID !== user.userID)
                : [...prev, user]
        )
    }

    const canActOnUser = (targetPortalRole) => {
        if (role === "admin") return true;
        if (role === "TechSupport") return targetPortalRole !== "admin" && targetPortalRole !== "TechSupport";
        return false;
    };

    const canViewRoles = (targetPortalRole) => {
        console.log(targetPortalRole);
        if (role === "operator") return false;
        return true;
    };

    const handleMassAction = (action) => {
        if (action === 'changeRole') setRoleDialogVisible(true)
        if (action === 'revokeAccess') setMassRevokeVisible(true)
    }

    const handleMassRevoke = async () => {
        setMassRevokeLoading(true)
        await Promise.all(
            selectedUsers.map(user => deleteGroupUser(ApiData, user.userID, dispatch))
        )
        setMassRevokeLoading(false)
        setMassRevokeVisible(false)
        setSelectedUsers([])
        setUpdate(prev => prev + 1)
    }

    const handleMassRoleChange = async (newRole) => {
        setRoleChangeLoading(true)
        if (newRole == "Manager") {
            newRole = "TechSupport"
        }
        if (singleRoleUser) {
            await changePortalRole(ApiData, { userID: singleRoleUser.userID, newRole }, dispatch)
        } else {
            await Promise.all(
                selectedUsers.map(user =>
                    changePortalRole(ApiData, { userID: user.userID, newRole }, dispatch)
                )
            )
            setSelectedUsers([])
        }
        setRoleChangeLoading(false)
        setRoleDialogVisible(false)
        setSingleRoleUser(null)
        setUpdate(prev => prev + 1)
    }

    const navigateToUserSites = (row) => {
        sessionStorage.setItem('userState', JSON.stringify({
            activeTab,
            portalFilter,
            selectedTime,
            dateRange
        }));
        console.log(row);
        const userID = row.userID ?? row.id;
        const fullName = row.fullName
        dataManager.setItem('clickedUserID', userID);
        dataManager.setItem('clickedUserEmailAddress', row.email)
        dataManager.setItem('clickedUserObj', row);
        localStorage.setItem('ClickedUserFullName', fullName);
        localStorage.setItem('clickedUserID', userID)
        dispatch(authActions.setClickedUserDetails({ userID, fullName }))
        dataManager.setItem('userSearchQuery', searchQuery)
        navigate("/Dashboard/Users/UserSites");

        //Save what was typed when clicking in, to restore when navigating back
    }

    const handleEmailClick = (row) => {
        setEmailPopupRow(row);
        setEmailPopupVisible(true);
    };

    const [modalTitle, setModalTitle] = useState("title")
    const [modalComponent, setModalComponent] = useState()

    const ModalDialog = useRef();

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
    }


    const HandleDelete = (userID) => {
        setUserIDToRevoke(userID)
        setRevokeVisible(true)
    }

    const DeleteUser = async (userID) => {
        const response = await deleteGroupUser(ApiData, userID, dispatch);
        if (response){
            setUpdate(update+1);
            setRevokeVisible(false)
        }
    }

    const HandleUserAction = async (userAction, userID, notifications, portalAccess, row) => {
        setSelectedEmail(row.email)
        switch (userAction) {
            case "Enable App Admin":
                const enableInstallerMode = async (apiData, userID) => {
                    const response = await switchInstallerMode(apiData, userID, "INSTALLER")
                    if (response) {
                        row.portalAccess = "INSTALLER"
                        setOpenDropdownRowId(null);
                    }
                }

                enableInstallerMode(apiData, userID)
                break;
            case "Disable App Admin":
                const disableInstallerMode = async (apiData, userID) => {
                    const response = await switchInstallerMode(apiData, userID, "")
                    if (response) {
                        row.portalAccess = ""
                        setOpenDropdownRowId(null);
                    }
                }

                disableInstallerMode(apiData, userID)
                break;
            case "Disable Notifications":
                const DisableUserNotifications = async (apiData, userId, notifications) => {
                    const disableNotifications = notifications == "no"
                    const responseData = await enableUserNotifications(apiData, userId, disableNotifications, dispatch)
                    if (responseData) {
                        row.notifications = "no"
                        setOpenDropdownRowId(null);
                    }
                }

                DisableUserNotifications(apiData, userID, notifications);
                break;
            case "Enable Notifications":
                const EnableUserNotifications = async (apiData, userId, notifications) => {
                    const enableNotification = notifications == "yes"
                    const responseData = await enableUserNotifications(apiData, userId, enableNotification, dispatch)
                    if (responseData) {
                        row.notifications = "yes"
                        setOpenDropdownRowId(null);
                    }
                }

                EnableUserNotifications(apiData, userID, notifications);
                break;
            case "Delete user account":
                setUserIDToDelete(userID)
                setConfirmVisible(true)
                break;
            case "Change role":
                setSingleRoleUser({ userID, fullName: row.fullName })
                setRoleDialogVisible(true)
                break;
            case "Revoke access":
                HandleDelete(userID)
                break;
            default:
                console.alert('Invalid option:', userAction);
        }
    }

    // -- Controls the settingCog wheel -------------------------------------- 
    const [openDropdownRowId, setOpenDropdownRowId] = useState(null);

    const DeleteUserAccount = async () => {
        setConfirmVisible(false);
        if (userIDToDelete != null){
            const body = {
                "userID": userIDToDelete
            }
            const response = await deleteUserAccount(apiData, body, dispatch)
            
            if (response.success) {
                //show success? 
                //Refresh user list?
                setData(prevData => prevData.filter(user => user.id !== userIDToDelete));
                setSuccessVisible(true)
                setOpenDropdownRowId(null);
            } else {
                if (response.msg == "Unauthorised"){
                    setFailVisible(true)
                }
            }
        }
    }

    const handleSettingsClick = (rowId) => {
        // If the clicked dropdown is already open, close it
        if (openDropdownRowId === rowId) {
        setOpenDropdownRowId(null);
        } else {
        // Otherwise, open the clicked dropdown
        setOpenDropdownRowId(rowId);
        }
    };

    useEffect(() => {
        const tabNumber = activeTab;

        const tabTracking = {
            0: "Users tab visited",
            1: "Group User Analytics visited"
        }

        if (tabTracking[tabNumber]) {
            mixpanel.track(tabTracking[tabNumber], {
              user: localStorage.getItem('email')
            });
        }
    }, [activeTab])

    useEffect(() => {
        if (savedState) {
            sessionStorage.removeItem('userState');
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(data) && data.length > 0) {
            //setIsLoading(false)
        }
    }, [data]);

    const dropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                // Clicked outside the dropdown menu, so close it
                setOpenDropdownRowId(null);
            }
        };

        // Add event listener to listen for clicks outside the dropdown menu
        document.addEventListener('click', handleClickOutside);

        return () => {
        // Cleanup: Remove event listener when component unmounts
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);
    // -----------------------------------------------------------------------

    useEffect(() => {
        if (selectedUsers.length > 0) {
            setMassActionsVisible(true)
        } else {
            setMassActionsVisible(false)
        }
    }, [selectedUsers])

    useEffect(() => {
        if (activeTab !== 1) return;
        const now = new Date();
        const last7 = new Date(); last7.setDate(now.getDate() - 7);
        const last30 = new Date(); last30.setDate(now.getDate() - 30);
        const last90 = new Date(); last90.setDate(now.getDate() - 90);
        const fetchUserStats = async () => {
            setIsLoadingUsers(true);
            const response = await getSiteAnalytics(apiDataRef.current, {
                groupName: companyName,
                start_date: selectedTime ? (selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90) : (dateRange ? new Date(dateRange[0]) : last7),
                end_date: selectedTime ? now : dateRange ? new Date(dateRange[1]) : now,
                analyticsType: "users",
                hasPortalUsers: portalFilter === "Exclude Portal Users" ? 1 : 0
            }, dispatch);
            setTopUserStats(response?.data?.[0]?.topUsers || []);
            setIsLoadingUsers(false);
        };
        fetchUserStats();
    }, [selectedTime, activeTab, portalFilter, dateRange]);

    const GetBrandingName = async (groupName) => {
        let body = {
            groupName: groupName ?? companyName
        }

        const response = await getBranding(ApiData, body, dispatch)
        if (response.success){
            setBrandingName(response.data["emailBranding"])
        }
    }

    useEffect(() => {
        GetBrandingName();
    }, [companyName]);

    const generatePDF = () => {
        const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        const pageW = doc.internal.pageSize.getWidth();
        const margin = 18;

        let startDate, endDate;
        if (selectedTime) {
            endDate = now;
            startDate = selectedTime === "7D" ? last7 : selectedTime === "1M" ? last30 : last90;
        } else if (dateRange) {
            startDate = new Date(dateRange[0]);
            endDate = new Date(dateRange[1]);
        } else {
            startDate = last7;
            endDate = now;
        }
        const dateRangeStr = `${format(startDate, "MMM d, yyyy")} - ${format(endDate, "MMM d, yyyy")}`;

        doc.setFont('helvetica', 'bold');
        doc.setFontSize(14);
        const titleText = `${companyName || localStorage.getItem('companyName') || ""} - User Stats`;
        const titleMaxWidth = pageW - margin * 2 - 25;
        const titleLines = doc.splitTextToSize(titleText, titleMaxWidth);
        const extraTitleHeight = (titleLines.length - 1) * 6;
        const headerHeight = 36 + extraTitleHeight;

        doc.setFillColor(28, 37, 54);
        doc.rect(0, 0, pageW, 32, 'F');

        if (logo) {
            const logoWidth = 17;
            const logoHeight = 17;
            const logoX = pageW - margin - logoWidth;
            const logoY = 4;
            doc.addImage(logo, 'PNG', logoX, logoY, logoWidth, logoHeight);
        }

        doc.setTextColor(255, 255, 255);
        doc.text(titleLines, margin, 10);

        let headerY = 10 + (titleLines.length * 2);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(12);
        doc.setFontSize(9);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(180, 195, 220);
        doc.text(dateRangeStr, margin, headerY + 7);
        doc.text(`Generated: ${format(new Date(), "MMM d, yyyy")}`, margin, headerY + 12);

        const filename = `users-report-${(companyName || localStorage.getItem('companyName') || "").toLowerCase()}-${format(new Date(), "yyyy-MM-dd")}.pdf`;

        let curY = headerHeight + 10;

        if (userBarChartRef.current) {
            const chart = userBarChartRef.current;

            chart.resize(800, 350);
            chart.update('none');

            const chartImage = chart.toBase64Image();

            chart.resize();
            chart.update('none');
            doc.addImage(chartImage, 'PNG', 15, curY, 180, 75);
            curY += 90;
        }

        if (topUserStats && topUserStats.length > 10) {
            curY += 5;
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(11);
            doc.setTextColor(30, 30, 30);
            doc.text('Users Report Details', margin, curY);
            curY += 6;

            const tableData = topUserStats.map(row => [
                row.fullName,
                row.total_actions
            ]);

            autoTable(doc, {
                startY: curY,
                margin: { left: margin, right: margin },
                head: [['User', 'Total Actions']],
                body: tableData,
                headStyles: { fillColor: [28, 37, 54], textColor: [255, 255, 255], fontSize: 8, fontStyle: 'bold' },
                bodyStyles: { fontSize: 8, textColor: [50, 50, 50] },
                alternateRowStyles: { fillColor: [249, 250, 251] },
                columnStyles: {
                    0: { cellWidth: 48 },
                    1: { cellWidth: 48 }
                },
                styles: { cellPadding: 3 },
            });
        }

        const pageH = doc.internal.pageSize.getHeight();
        doc.setFillColor(28, 37, 54);
        doc.rect(0, pageH - 14, pageW, 14, 'F');
        doc.setTextColor(180, 195, 220);
        doc.setFontSize(7);
        doc.setFont('helvetica', 'normal');
        doc.text('Portal Analytics Report', pageW / 2, pageH - 6, { align: 'center' });
        doc.save(filename);
    };

    const tableColumnsDefault = [
        {
            id: 'name', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Name</h3>
                </div>
            ),
            accessorKey: 'fullName',
            cell: (row) => {
                return (
                    <div onClick={() => navigateToUserSites(row.row.original)} 
                        className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#6996f1"}
                            PillColor_IfFalse={"#626a67"}
                            text_IfTrue={row.row.original.fullName}
                            className={classes.PillHeight}
                        />
                    </div>
                )
            }
        },
        {
            id: 'email',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Email address</h3>
                </div>
            ),
            accessorKey: 'email',
            cell: (row) => {
                return (
                    <div onClick={() => handleEmailClick(row.row.original)} className={classes.tableValueText} style={{ cursor: "pointer", color: "#1a73e8", textDecoration: "underline" }}>
                        {row.row.original.email}
                    </div>
                )
            }
        },
        {
            id: 'numberOfSites',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Number of sites</h3>
                </div>
            ),
            cell: (row) => {
                const numberOfSites = row.row.original.siteCount
                return (
                    <>
                    <p className={classes.tableTitleText}>{numberOfSites}</p>
                </>
                )
            }
        },
        {
            id: 'Account created', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Account created</h3>
                </div>
            ),
            accessorKey: 'lastLoggedIn',
            cell: (row) => {
                const lastLoggedIn = row.row.original.created;
                const displayValue = lastLoggedIn
                ? UseTimeDateFormat(lastLoggedIn)
                : { date: "Never logged in", time: "" };

                const { date, time } = displayValue;
                return (
                    <>
                        <p className={classes.tableTitleText}>{date + ", " + time}</p>
                    </>
                )
            },
        },
        {
            id: 'appAdmin',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>App admin</h3>
              </div>
            ), //Grey tick vs green for password vs no password
            accessorKey: 'portalAccess',
            cell: (row) => {
              return (
                <div onClick={() => navigateToUserSites(row.row.original)}>
                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && (
                         <img className={classes.Icon} src={AdminIcon} 
                     />
                    )}     
                </div>
              )
            }
          },
          {
            id: 'portalAccess',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Portal access</h3>
              </div>
            ),
            accessorKey: 'portalAccess',
            hidden: !!hidePortalAccess,
            cell: (row) => {
                let groupName = row.row.original.portalGroupName
                if (groupName == "EyeSpyFX"){
                    groupName = "Inniovate"
                }
              return (
                <div onClick={() => navigateToUserSites(row.row.original)}>

                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && row.row.original.portalAccess.trim() !== "INSTALLER" && row.row.original.portalPassword && row.row.original.portalPassword !== "" && (
                         <img className={classes.Icon} src={check}     
                     />
                    )}  

                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && row.row.original.portalAccess.trim() !== "INSTALLER" && row.row.original.portalPassword == "" && (
                         <img className={classes.Icon} src={invited}     
                     />
                    )}  

                    {isGroupWithinHierarchy(row.row.original.portalGroupName) && (

                        <span
                            onClick={(e) => { e.stopPropagation(); navigateToGroup(row.row.original.portalGroupName); }}
                            style={{ cursor: "pointer" }}
                        >
                            <Pill_Widget
                                boolean={true}
                                PillColor_IfTrue={"#606060"}
                                PillColor_IfFalse={"#626a67"}
                                text_IfTrue={groupName}
                                className={classes.PillHeight}
                            />
                        </span>


                    )}

                </div>
              )
            }
          },
          {
            id: 'notifications',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Notifications enabled</h3>
              </div>
            ),
            accessorKey: 'portalAccess',
            cell: (row) => {
              return (
                <div onClick={() => navigateToUserSites(row.row.original)}>
                    {row.row.original.notifications && row.row.original.notifications.trim() == "yes" && (
                         <img className={classes.Icon} src={AdminIcon}     
                     />
                    )}     
                </div>
              )
            }
          },
          {
            //Settings cog
            id: 'delete',
            cell: (row) => {
                if (!canActOnUser(row.row.original.portalRole)) return null;
                return (
                    <div className={classes["icons-container"]}>
                        <img className={classes.Icon} src={DeleteIcon}
                            onClick={() => HandleDelete(row.row.original.userID)}
                        />
                    </div>
                    )
            },
            hidden: !isGroup || (role !== "admin" && role !== "TechSupport"),
          },
          {
            id: 'userSettings',
            cell: (row) => {
                let items = [
                    {
                        image:
                            row.row.original.notifications == "yes"
                                ? InactiveNotificationBellIcon
                                : ActiveNotificationBellIcon,
                        title:
                            row.row.original.notifications == "yes"
                                ? "Disable Notifications"
                                : "Enable Notifications",
                    },
                    {
                        image:
                            row.row.original.portalAccess != "" && row.row.original.portalAccess != null
                                ? installerInactive
                                : installerActive,
                        title:
                            row.row.original.portalAccess != "" && row.row.original.portalAccess != null
                                ? "Disable App Admin"
                                : "Enable App Admin",

                    },
                ];

                if (canActOnUser(row.row.original.portalRole)) {
                    items.push({ image: deleteIcon, title: "Delete user account" });
                }

                const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
                if (role !== "admin" && role !== "TechSupport") return null;
                return <DropdownList
                    item={row.row.id}
                    icon={SettingsIcon}
                    onClick={handleSettingsClick}
                    ifSettingsCogIsClicked={ifSettingsCogIsClicked}
                    ref={dropdownRef}
                    title={"Actions"}
                    className={classes.container}
                    onUserActionClick={(userAction) =>
                        HandleUserAction(userAction, row.row.original.id, row.row.original.notifications, row.row.original.portalAccess, row.row.original)
                    }
                    listItems={items}
                />
            },
            hidden: isGroup
          },
      ];

    const tableColumnsGroupUsers = [
        {
            id: 'select',
            header: () => null,
            cell: (row) => {
                const user = row.row.original
                const isChecked = selectedUsers.some(u => u.userID === user.userID)
                return (
                    <div onClick={e => e.stopPropagation()} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <Checkbox
                            onChange={() => toggleUserSelection(user)}
                            checked={isChecked}
                        />
                       
                    </div>
                )
            },
            hidden: role !== 'admin',
        },
         {
            id: 'name',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Name</h3>
                </div>
            ),
            accessorKey: 'fullName',
            cell: (row) => {
                return (
                    <div onClick={() => navigateToUserSites(row.row.original)} 
                        className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#6996f1"}
                            PillColor_IfFalse={"#626a67"}
                            text_IfTrue={row.row.original.fullName}
                            className={classes.PillHeight}
                        />
                    </div>
                )
            }
        },
        {
            id: 'email',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Email address</h3>
                </div>
            ),
            accessorKey: 'email',
            cell: (row) => {
                return (
                    <div onClick={() => handleEmailClick(row.row.original)} className={classes.tableValueText} style={{ cursor: "pointer", color: "#1a73e8", textDecoration: "underline" }}>
                        {row.row.original.email}
                    </div>
                )
            }
        },

        {
            id: 'lastLoggedin', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Last logged in</h3>
                </div>
            ),
            accessorKey: 'lastLoggedIn',
            cell: (row) => {
                const lastLoggedIn = row.row.original.lastLoggedIn;
                const displayValue = lastLoggedIn
                ? UseTimeDateFormat(lastLoggedIn)
                : { date: "Never logged in", time: "" };

                const { date, time } = displayValue;
                return (
                    <>
                        <p className={classes.tableTitleText}>{date + ", " + time}</p>
                    </>
                )
            },
        },
        {
            id: 'portalAccess',
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                  <h3>Portal access</h3>
              </div>
            ),
            accessorKey: 'portalAccess',
            cell: (row) => {
              return (
                <div onClick={() => navigateToUserSites(row.row.original)}>

                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && row.row.original.portalAccess.trim() !== "INSTALLER" && row.row.original.portalPassword && row.row.original.portalPassword !== "" && (
                         <img className={classes.Icon} src={check}     
                     />
                    )}  

                    {row.row.original.portalAccess && row.row.original.portalAccess.trim() !== "" && row.row.original.portalAccess.trim() !== "INSTALLER" && row.row.original.portalPassword == "" && (
                         <img className={classes.Icon} src={invited}     
                     />
                    )}  

                     

                </div>
              )
            }
          },
          {
            id: 'accessLevel', 
            header: () => (
                <div className={classes.tableTitleText} title="Click to sort">
                    <h3>Role</h3>
                </div>
            ),
            accessorKey: 'portalRole',
            cell: (row) => {
                if (!canViewRoles(row.row.original.portalRole)) return null;
                return (
                    <div
                        className={classes.tableValueText}>
                        <Pill_Widget
                            boolean={true}
                            PillColor_IfTrue={"#6996f1"}
                            PillColor_IfFalse={"#626a67"}
                            text_IfTrue={row.row.original.portalRole === "TechSupport" ? "Manager" : row.row.original.portalRole === "admin" ? "Admin" : row.row.original.portalRole}
                            className={classes.PillHeight}
                        />
                    </div>
                )
            }
        },
          {
            id: 'delete',
            cell: (row) => {
                if (!canActOnUser(row.row.original.portalRole)) return null;
                const items = [
                    ...(role === "admin" ? [{ image: swapSettings, title: "Change role" }] : []),
                    { image: DeleteIcon, title: "Revoke access" },
                ];
                const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
                return (
                    <DropdownList
                        item={row.row.id}
                        icon={SettingsIcon}
                        onClick={handleSettingsClick}
                        ifSettingsCogIsClicked={ifSettingsCogIsClicked}
                        ref={dropdownRef}
                        title={"Actions"}
                        className={classes.container}
                        onUserActionClick={(userAction) =>
                            HandleUserAction(userAction, row.row.original.userID, row.row.original.notifications, row.row.original.portalAccess, row.row.original)
                        }
                        listItems={items}
                    />
                )
            },
            hidden: !isGroup || (role !== "admin" && role !== "TechSupport"),
          },
          {
            id: 'userSettings', 
            cell: (row) => {
                let items = [
                    {
                        image:
                            row.row.original.notifications == "yes"
                                ? InactiveNotificationBellIcon
                                : ActiveNotificationBellIcon,
                        title:
                            row.row.original.notifications == "yes"
                                ? "Disable Notifications"
                                : "Enable Notifications",
                    },
                    {
                        image: 
                            row.row.original.portalAccess != "" && row.row.original.portalAccess != null
                                ? installerInactive
                                : installerActive,
                        title: 
                            row.row.original.portalAccess != "" && row.row.original.portalAccess != null
                                ? "Disable App Admin"
                                : "Enable App Admin",
            
                    }
                ];
                
                const ifSettingsCogIsClicked = openDropdownRowId === row.row.id
                return <DropdownList
                    item={row.row.id}
                    icon={SettingsIcon}
                    onClick={handleSettingsClick}
                    ifSettingsCogIsClicked={ifSettingsCogIsClicked}
                    ref={dropdownRef}
                    title={"Actions"}
                    className={classes.container}
                    onUserActionClick={(userAction) => 
                        HandleUserAction(userAction, row.row.original.id, row.row.original.notifications, row.row.original.portalAccess, row.row.original)
                    }
                    listItems={items}
                />
            },
            hidden: isGroup
          },
    ]

    useEffect(() => {
    }, [selectedEmail])

    const tableColumns = isPortalUsers ? tableColumnsGroupUsers : tableColumnsDefault

    const filteredTableColumns = tableColumns.filter(column => !column.hidden);

    return (
        <>
        <Modal ref={ModalDialog} title={modalTitle} modalName={"Site View"} HandleShowModal={HandleShowModal}>
            {modalComponent}
        </Modal>

        

        <Dialog
            header="Success"
            visible={successVisible}
            style={{ width: "40vw" }}
            onHide={() => setSuccessVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <h3 style={{color:"#6e6e6eff"}}>User account deleted successfully.</h3>
                <Lottie
                    animationData={successAnim}
                    loop={false}
                    style={{ width: 250, height: 250, margin: "0px" }}
                />

                <Button label="Close" icon="pi pi-times" rounded severity="primary" onClick={() => setSuccessVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header="Error"
            visible={failVisible}
            style={{ width: "40vw" }}
            onHide={() => setFailVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={failAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br/>
                <h3 style={{color:"#6e6e6eff"}}>Unauthorised</h3>
            <p style={{textAlign:"center"}}>You are not authorsied to delete this user account, only users within your domain can be deleted</p>
           <br></br>

                <Button label="Okay" rounded severity="secondary" onClick={() => setFailVisible(false)}/>
            </div>
        </Dialog>

        <Dialog
            header={`Revoke access for ${selectedUsers.length} user${selectedUsers.length !== 1 ? 's' : ''}?`}
            visible={massRevokeVisible}
            style={{ width: "40vw" }}
            onHide={() => setMassRevokeVisible(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie animationData={areYouSureAnim} loop={false} style={{ width: 150, height: 150, margin: "0px" }} />
                <br/>
                <h3 style={{ color: "#6e6e6eff", textAlign: "center" }}>Are you sure you want to revoke access for {selectedUsers.length} user{selectedUsers.length !== 1 ? 's' : ''}?</h3>
                <br/>
                <Button label="No, cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setMassRevokeVisible(false)} />
                <br/>
                <Button label="Yes, revoke all" rounded icon="pi pi-check" severity="danger" loading={massRevokeLoading} onClick={handleMassRevoke} />
            </div>
        </Dialog>

        <Dialog
            header="Revoke access?"
            visible={revokeVisible}
            style={{ width: "40vw" }}
            onHide={() => setRevokeVisible(false)}
        >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Lottie
                    animationData={areYouSureAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
                <br/>
                <h3 style={{ color: "#6e6e6eff", textAlign: "center" }}>Are you sure you want to revoke this user's access?</h3>
                <br/>
                <Button label="No, cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setRevokeVisible(false)} />
                <br/>
                <Button label="Yes, I'm sure" rounded icon="pi pi-check" severity="danger" onClick={() => DeleteUser(userIDToRevoke)} />
            </div>
        </Dialog>

        <Dialog
            header="Are you sure?"
            visible={confirmVisible}
            style={{ width: "40vw" }}
            onHide={() => setConfirmVisible(false)}
            >
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>

                <Lottie
                    animationData={areYouSureAnim}
                    loop={false}
                    style={{ width: 150, height: 150, margin: "0px" }}
                />
            <br/>
            <h3 style={{color:"#6e6e6eff"}}>{`Are you sure you want to delete ${selectedEmail}`}</h3>
            <p>This is a PERMANENT action and cannot be undone!</p>
                <br/>
                <Button label="No cancel" rounded icon="pi pi-times" severity="secondary" onClick={() => setConfirmVisible(false)}/>
                <br/>
                <Button label="Yes, delete account" rounded icon="pi pi-check" severity="danger" onClick={() => DeleteUserAccount()}/>

            </div>
        </Dialog>

        <Dialog
            header={emailPopupRow?.email}
            visible={emailPopupVisible}
            style={{ width: "fit-content", minWidth: "320px", maxWidth: "90vw" }}
            onHide={() => { setEmailPopupVisible(false); setEmailCopied(false); }}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <Button
                    label="Send email"
                    icon="pi pi-envelope"
                    severity="secondary"
                    outlined
                    style={{ justifyContent: "flex-start" }}
                    onClick={() => {
                        window.location.href = `mailto:${emailPopupRow?.email}`;
                        setEmailPopupVisible(false);
                    }}
                />
                <Button
                    label={emailCopied ? "Copied!" : "Copy email address"}
                    icon={emailCopied ? "pi pi-check" : "pi pi-copy"}
                    severity="secondary"
                    outlined
                    style={{ justifyContent: "flex-start" }}
                    onClick={() => {
                        navigator.clipboard.writeText(emailPopupRow?.email ?? "");
                        setEmailCopied(true);
                    }}
                />
                <Button
                    label="View profile"
                    icon="pi pi-user"
                    severity="primary"
                    style={{ justifyContent: "flex-start" }}
                    onClick={() => {
                        setEmailPopupVisible(false);
                        navigateToUserSites(emailPopupRow);
                    }}
                />
            </div>
        </Dialog>

        <Dialog
            header={singleRoleUser ? `Change role — ${singleRoleUser.fullName}` : `Change portal role — ${selectedUsers.length} user${selectedUsers.length !== 1 ? 's' : ''}`}
            visible={roleDialogVisible}
            style={{ width: '360px' }}
            onHide={() => { setRoleDialogVisible(false); setSingleRoleUser(null); }}
        >
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <p style={{ color: '#6e6e6e', fontSize: 'var(--font-normal)', marginBottom: '8px' }}>
                    Select the role to assign to all selected users:
                </p>
                {roleOptions.map(r => (
                    <Button
                        key={r}
                        label={r}
                        outlined
                        severity="secondary"
                        loading={roleChangeLoading}
                        onClick={() => handleMassRoleChange(r)}
                        style={{ justifyContent: 'flex-start' }}
                    />
                ))}
            </div>
        </Dialog>

        <div style={{ width: "100%" }}>
            <div className={classes.tabsWrapper}>
                {!isPortalUsers && (
                    <div className={classes.tabs}>
                        {["Users", "User Analytics"].map((tab, i) => (
                            <button
                                key={tab}
                                className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                                onClick={() => setActiveTab(i)}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                )}
                <div className={classes.tabContent}>
                    {activeTab === 0 && (
                        <>
                            {massActionsVisible && (role === 'admin' || role === 'TechSupport') && (
                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '8px 4px', marginBottom: '8px' }}>
                                    <span style={{ fontSize: 'var(--font-normal)', color: '#6e6e6e', whiteSpace: 'nowrap' }}>
                                        {selectedUsers.length} user{selectedUsers.length !== 1 ? 's' : ''} selected
                                    </span>
                                    <Dropdown
                                        value={null}
                                        options={massActionOptions}
                                        onChange={(e) => handleMassAction(e.value)}
                                        placeholder="Actions"
                                        style={{ fontSize: 'var(--font-normal)' }}
                                    />
                                    <Button
                                        label="Clear"
                                        icon="pi pi-times"
                                        text
                                        severity="secondary"
                                        onClick={() => setSelectedUsers([])}
                                        style={{ fontSize: 'var(--font-normal)', padding: '6px 10px' }}
                                    />
                                </div>
                            )}
                            <div className={classes["tableCardLayoutUI-wrapper"]} style={{ padding: "0px 10px 0px 10px" }}>
                                <Await resolve={data}>
                                    {(loadedTableData) => {
                                        return (
                                            <>
                                            <br></br>
                                            <div style={{ width: "auto", minWidth: "500px", height: "100%", minHeight: "500px" }}>
                                                {isLoading ? (
                                                    <div style={{ display: "flex", width: "100%" }}>
                                                        <DeviceLoadingGrid CardCount={100} />
                                                    </div>
                                                ) : (
                                                    <BasicTable
                                                        data={loadedTableData}
                                                        columns={filteredTableColumns}
                                                        filtering={""}
                                                        rowClick={false}
                                                        ShowPagination={false}
                                                        PageSize={5000}
                                                        paginationOptions={[25, 50, 100]}
                                                        showFilterButton={false}
                                                        isSortable={true}
                                                    />
                                                )}
                                            </div>
                                            </>
                                        )
                                    }}
                                </Await>
                            </div>
                        </>
                    )}
                    {activeTab === 1 && (
                        <>
                            <SectionHeaderTime
                                title="User Stats"
                                times={times}
                                selectedTime={selectedTime}
                                setSelectedTime={setSelectedTime}
                                portalFilter={portalFilter}
                                setPortalFilter={setPortalFilter}
                                showModal={showModal}
                                HandleCloseModal={HandleModalClose}
                                modalTitle={dateModalTitle}
                                onSelect={onSelect}
                                handleOK={handleOK}
                                disableDates={disableDates}
                                modalComponent={dateModalComponent}
                                dateRange={dateRange}
                                setDateRange={setDateRange}
                                generatePDF={generatePDF}
                                topUserStats={topUserStats}/>
                            <br />
                            {isLoadingUsers ? (
                                <> <SkeletonBarChart /> <br /> <SkeletonTableCard /> </>
                            ) : topUserStats && topUserStats.length > 0 ? (
                                <>
                                    <BarCard
                                        title="Top 10 users by output actions"
                                        labels={topUserStats.slice(0, 10).map(u => u.fullName)}
                                        values={topUserStats.slice(0, 10).map(u => u.total_actions)}
                                        colors={["#60e08f", "#6298ee", "#efbc65", "#df7474", "#75c71e", "#1eb9c7"]}
                                        topUserData={topUserStats}
                                        onUserClick={(userID, fullName) => navigateToUserSites({ userID, fullName })}
                                        chartRef={userBarChartRef}
                                    />
                                    <br />
                                    {topUserStats.length > 10 && (
                                        <TableCard
                                            title="Top 50 users by output actions"
                                            topUserData={topUserStats}
                                            onUserClick={(userID, fullName) => navigateToUserSites({ userID, fullName })}
                                        />
                                    )}
                                </>
                            ) : (
                                <p style={{ textAlign: "center", color: "#888888", marginTop: "2rem" }}>No user activity data available for this time period.</p>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
        </>
    )
}

export default UserList;